export default __webpack_public_path__ + "static/media/Mulish-Medium.03f90a01.ttf";